// import { useEffect, useState } from "react";
// import { getLocale } from "react-i18nify";
import styled from "styled-components";

import device from "src/styles/device";
import font from "src/styles/font";

import { Grid, Box } from "@mui/material";

import DocumentGrid from "./DocumentGrid";
import SummaryDetailGrid from "./SummaryDetailGrid";

const TextRemark = styled(Box)`
  width: 100%;
  color: var(--darkgrey-color);
  font-size: ${font.size.sm};
  font-weight: 400;
  line-height: 2.2;
  padding: 16px;
  white-space: pre-line;
  word-break: break-word;

  @media ${device.mobileL} {
    padding: 16px 10px;
  }
`;

const Step2 = ({ formErrors, formData, dataProductList, dataServiceType }) => {
  return (
    <>
      {/* Summary detail */}
      <SummaryDetailGrid formData={formData} />

      {/* Product Table */}
      <DocumentGrid
        isDetail={true}
        formData={formData}
        formErrors={formErrors}
        dataProductList={dataProductList}
        dataServiceType={dataServiceType}
      />

      {/* Remark */}
      <Grid
        container
        sx={{
          mt: 3,
          px: {
            xs: 3,
            sm: 5,
            md: 0,
          },
          fontSize: font.size.md,
          ".MuiAutocomplete-root": {
            margin: 0,
          },
          ".MuiTextField-root": {
            borderRadius: "24px",
          },
          ".MuiOutlinedInput-root": {
            borderRadius: "24px",
          },
          ".MuiInputBase-inputMultiline": {
            p: 0,
            textAlign: "left",
          },
          ".MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
            {
              px: 0,
            },
        }}
      >
        {formData?.remark !== "" ? (
          <Grid
            item
            xs={12}
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: {
                xs: "center",
                md: "flex-start",
              },
              justifyContent: "center",
            }}
          >
            <TextRemark>{formData?.remark}</TextRemark>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default Step2;
